import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'rwidget-map-polyline-point',
    template: ``,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapPolylinePointComponent {
    @Input() latitude!: number;

    @Input() longitude!: number;
}
